import { render } from "./MlServer_recPhoto.vue?vue&type=template&id=135002b6&scoped=true"
import script from "./MlServer_recPhoto.vue?vue&type=script&lang=js"
export * from "./MlServer_recPhoto.vue?vue&type=script&lang=js"

import "./MlServer_recPhoto.vue?vue&type=style&index=0&id=135002b6&lang=scss&scoped=true"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-135002b6"]])

export default __exports__